import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "ClasePage",
    data() {
        let ss = new MainService();
        return {
            msg: "ClasePage",
            ss: ss,
            ajax: {
                "url": ss.indexClase(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N°', orderable: false, searchable: false },
                { data: 'Clase', name: 'Clase', title: 'Clase' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            clases: [],
            clase: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newClase() {
            this.clase = {};
            this.$refs['frm-clase'].show();
        },
        showClase(id) {
            this.isLoading=true;
            this.ss.showClase(id).then(
                (result) => {
                    let response = result.data;
                    this.clase = response.data;
                    this.$refs['view-clase'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editClase() {
            this.$refs['frm-clase'].show();
            this.$refs['view-clase'].hide();
        },
        cancelClase() {
            if (this.clase.id) {
                this.$refs['view-clase'].show();
            }
            this.$refs['frm-clase'].hide();
        },
        saveClase() {
            this.ss.storeClase(this.clase).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-clase'].hide();
                    this.$refs['datatable-clase'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteClase() {
            this.$swal({
                title: "Estás seguro que deseas eliminar?",
                text: "Esta acción es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyClase(this.clase)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-clase'].hide();
                                this.$refs['datatable-clase'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-Clase').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showClase(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
